import { useEffect } from "react";
import { balanceStore } from "./balanceStore";

/** Restore this tab's balance in the signed-in app, including back/forward cache returns. */
export function useBalanceConnection(): void {
  useEffect(() => {
    void balanceStore.restoreConnection();
    const suspend = () => void balanceStore.suspendConnection();
    const resume = (event: PageTransitionEvent) => {
      if (event.persisted) void balanceStore.restoreConnection();
    };
    window.addEventListener("pagehide", suspend);
    window.addEventListener("pageshow", resume);
    return () => {
      window.removeEventListener("pagehide", suspend);
      window.removeEventListener("pageshow", resume);
      // Page changes and React's effect replay must not disconnect the shared device.
    };
  }, []);
}
